<template>
  <div>
    <!--    面包屑-->
    <header class="header">
      <div style="position: absolute;left: 16px;top: 17px;font-weight: bolder">应用权限管理</div>
      <div style="position: absolute;right: 16px;top: 8px">
        <el-autocomplete
            v-model="createAppAuthorityForm.username"
            :fetch-suggestions="usernameSuggestions"
            value-key="name"
            @select="handleCreateAuthorityUserSearch"
            placeholder="">
        </el-autocomplete>
        <el-button type="primary" @click="handleCreateAppAuthority">添加用户</el-button>
      </div>
    </header>

    <!--    表格-->
    <main class="main">
      <header>
        <section>
          {{ appInfo.appName }}的所有管理用户
        </section>
      </header>

      <!--      表格主体-->
      <article
          class="table"
          v-loading="loadingData">
        <el-table
            :empty-text="'没有数据'"
            :data="appAuthorityList"
            :fit="true"
            style="width: 100%">
          <el-table-column
              type="index"
              label="序号"
              :index="indexMethod" width="90px">
          </el-table-column>
          <el-table-column
              prop="name"
              label="用户名">
            <template #default="scope">
              <div> {{ scope.row.realname }} ({{scope.row.username }})</div>
            </template>
          </el-table-column>
          <el-table-column label="应用管理员权限">
            <template slot-scope="scope">
              <el-switch
                  v-model="scope.row.enableCheckRelease"
                  active-color="#13ce66"
                  inactive-color="#ff4949"
                  @change="handleModifyAppAuthority(scope.row.appAuthorityId,scope.row.enableCheckRelease)">
              </el-switch>
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-link type="danger" @click="handleDeleteAppAuthority(scope.row.appAuthorityId)">删除</el-link>
            </template>
          </el-table-column>
        </el-table>
      </article>

      <!--      分页-->
      <footer class="main-footer">
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentPageChange"
            :current-page="pageData.currentPage"
            :page-sizes="[10, 15]"
            :page-size="pageData.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="pageData.totalElements">
        </el-pagination>
      </footer>
    </main>
  </div>
</template>

<script>
import {findSimilarUsername} from "@/api/User";
import {Message} from "element-ui";
import {createAppAuthority, deleteAppAuthority, findAllAppAuthorityByAppId} from "@/api/AppInfo";
import {modifyAppAuthority} from "@/api/AppAuthority";

function AppAuthorityByAppId(data) {
  this.appAuthorityId = data.appAuthorityId
  this.userId = data.userId
  this.username = data.username
  this.realname = data.realname ?? ""
  this.enableCreateRelease = data.enableCreateRelease
  this.enableCheckRelease = data.enableCheckRelease
}

export default {
  name: "AppAuthorityList",
  mounted() {
    this.loadAppAuthorityByAppId()
  },
  data() {
    return {
      loadingData: false,
      addAppAuthorityVisible: false,
      appInfo: {
        appId: this.$route.query.appId,
        appName: this.$route.query.appName
      },
      appAuthorityList: [],
      createAppAuthorityForm: {
        userId: undefined
      },
      userSearchForm: {
        userId: undefined
      },
      pageData: {
        currentPage: 1,
        totalPages: undefined,
        pageSize: 10,
        totalElements: undefined
      }
    }
  },
  methods: {
    loadAppAuthorityByAppId() {
      this.loadingData = true;
      this.loadingData = true;
      findAllAppAuthorityByAppId(this.appInfo.appId).then(res => {
        this.appAuthorityList = []
        res.data.content.forEach(e => {
          let appAuthority = new AppAuthorityByAppId(e)
          this.appAuthorityList.push(appAuthority)
        })
        this.pageData.currentPage = res.data.number + 1;
        this.pageData.totalPages = res.data.totalPages;
        this.pageData.pageSize = res.data.size;
        this.pageData.totalElements = res.data.totalElements;
        this.loadingData = false;
      }).catch(() => {
        this.loadingData = false;
      })
    },
    indexMethod(index) {
      return index + 1
    },
    handleCurrentPageChange(val) {
      this.loadUsers(val, this.pageData.pageSize)
    },
    handleSizeChange(val) {
      this.loadUsers(this.pageData.currentPage, val)
    },
    usernameSuggestions(queryString, cb) {
      findSimilarUsername(queryString).then(res => {
        if(res.data) {
          res.data.forEach((i) => {
            i.name = i.realname ? i.realname + '('+i.username+')' : i.username
          })
        }
        cb(res.data)
      })
    },
    handleCreateAuthorityUserSearch(item) {
      this.createAppAuthorityForm.userId = item.id
    },
    handleCreateAppAuthority() {
      if (this.createAppAuthorityForm.userId === undefined) {
        Message({
          message: "请输入要添加的管理员的名字",
          type: "error",
          duration: 3 * 1000
        })
      } else {
        createAppAuthority(this.appInfo.appId, this.createAppAuthorityForm.userId).then(() => {
          Message({
            message: "添加管理员成功",
            type: "success",
            duration: 3 * 1000
          })
          this.loadAppAuthorityByAppId()
        })
      }
    },
    handleDeleteAppAuthority(appAuthorityId) {
      this.$confirm('此操作将永久用户权限?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteAppAuthority(appAuthorityId).then(() => {
          this.$message({
            type: 'success',
            message: '成功删除权限!'
          });
          this.loadAppAuthorityByAppId()
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    handleModifyAppAuthority(appAuthorityId, enableCheckRelease) {
      modifyAppAuthority(appAuthorityId, enableCheckRelease).then(() => {
        Message({
          message: "成功修改用户权限",
          type: "success",
          duration: 3 * 1000
        })
      })
    }
  }
}
</script>

<style scoped>
.header {
  width: 100%;
  height: 56px;
  background: #f4f9ff;
}

.main {
  margin: 12px 16px;
  background: #ffffff;
  border-radius: 4px;
  min-height: calc(100vh - 44px - 56px - 24px - 50px);
  padding: 22px 32px;
  position: relative;
}

.table {
  margin-top: 20px;
}

.main-footer {
  position: absolute;
  bottom: 24px;
  left: calc(50% - 263px);
}

.main-header-search {
  position: absolute;
  right: 0;
  top: 0;
}
</style>
